import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { LinkButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Modal, ModalTypes } from '@eika/modal';
import WelcomeIcon from '../icons/heart-hands.svg';
import '../styles.scss';
const WelcomePage = _ref => {
  let {
    submitButtonText,
    onSubmit,
    goBackText,
    goBackCallback,
    products = []
  } = _ref;
  const [showHelpModal, setShowHelpModal] = useState(false);
  const toggleModal = () => {
    setShowHelpModal(!showHelpModal);
  };
  const closeHelpModal = () => {
    setShowHelpModal(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "welcome-icon-wrapper"
  }, /*#__PURE__*/React.createElement("img", {
    src: WelcomeIcon,
    alt: "Welcome logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: "welcome-page-content"
  }, /*#__PURE__*/React.createElement("header", {
    className: "main-header"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h2"
  }, "Kundeerkl\xE6ring antihvitvask")), /*#__PURE__*/React.createElement("div", {
    className: "panel-tekst"
  }, /*#__PURE__*/React.createElement("p", {
    className: "no-margin-paragraph"
  }, "Hvitvaskingsloven p\xE5legger bankene \xE5 ha kunnskap om sine kunder. Du m\xE5 derfor svare p\xE5 noen sp\xF8rsm\xE5l om hvordan du bruker v\xE5re produkter og tjenester."), (products === null || products === void 0 ? void 0 : products.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "products-list"
  }, /*#__PURE__*/React.createElement("h5", null, "Dine produkter"), /*#__PURE__*/React.createElement("ul", null, products.map(product => /*#__PURE__*/React.createElement("li", {
    key: product.name
  }, product.name)))), /*#__PURE__*/React.createElement("div", {
    className: "why-wrapper"
  }, /*#__PURE__*/React.createElement(LinkButton, {
    icon: IconTypes.INFO_24,
    onClick: toggleModal,
    id: "questionnaire_button_why"
  }, "Mer info om hvitvaskingsloven")))), /*#__PURE__*/React.createElement(Modal, {
    id: "welcome-why-modal",
    onClose: closeHelpModal,
    show: showHelpModal,
    type: ModalTypes.STANDARD,
    appNamespace: "kyc-declaration.app"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sub-card-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "small-h2"
  }, "Hvorfor m\xE5 jeg svare p\xE5 dette?")), /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("p", null, "Finansn\xE6ringen er p\xE5lagt \xE5 forhindre hvitvasking av penger samt terrorfinansiering. God kunnskap om deg som kunde og din bruk av finansielle tjenester er derfor n\xF8dvendig. Det inneb\xE6rer at du som kunde vil kunne f\xE5 sp\xF8rsm\xE5l som kan oppleves som uvanlige."), /*#__PURE__*/React.createElement("h4", null, "Nye privatkunder"), /*#__PURE__*/React.createElement("p", null, "Nye privatkunder m\xE5 opplyse om navn, f\xF8dselsnummer eller D-nummer, fast adresse og fremvise legitimasjon. I tillegg m\xE5 du opplyse om:"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "kundeforholdets form\xE5l og tilsiktede art"), /*#__PURE__*/React.createElement("li", null, "hvorfor du \xF8nsker \xE5 gjennomf\xF8re st\xF8rre transaksjoner"), /*#__PURE__*/React.createElement("li", null, "hvor pengene kommer fra eller hva de skal brukes til"), /*#__PURE__*/React.createElement("li", null, "du eller noen n\xE6rst\xE5ende har et h\xF8ytst\xE5ende verv eller stilling i utlandet")), /*#__PURE__*/React.createElement("h4", null, "Hva er hvitvasking av penger"), /*#__PURE__*/React.createElement("p", null, "Enhver transaksjon som bidrar til \xE5 skjule opprinnelsen til penger som stammer fra en kriminell handling, anses som hvitvasking av penger."), /*#__PURE__*/React.createElement("p", null, "Hvitvasking skjer for eksempel n\xE5r utbytte fra skatte-unndragelse, narkotikakriminalitet, bedrageri og annen \xF8konomisk kriminalitet overf\xF8res fra en person eller et foretak til en annen med en tilsynelatende god forklaring. Utad virker det som pengene er ervervet p\xE5 \xE6rlig vis."), /*#__PURE__*/React.createElement("p", null, "Dette kan gj\xF8res ved \xE5 plassere utbytte i lovlige varer og tjenester. N\xE5r gjenstanden senere benyttes eller selges, fremst\xE5r pengene som lovlige \u2013 eller \"hvite\". Hvitvaskingsloven gjennomf\xF8rer internasjonale forpliktelser Norge er bundet av."), /*#__PURE__*/React.createElement("p", null, "Bakgrunnen for den nye loven er et p\xE5legg fra EU og internasjonale anbefalinger fra bl.a. FATF. (Det internasjonale overv\xE5kingsorganet Financial Action Task Force)"), /*#__PURE__*/React.createElement("h4", null, "Verdt \xE5 vite"), /*#__PURE__*/React.createElement("p", null, "I noen tilfeller m\xE5 institusjonen nekte \xE5 gjennomf\xF8re en forespurt tjeneste. \xC5rsaken kan v\xE6re at gyldig legitimasjon ikke er vist, eller at det ikke er gitt tilstrekkelige opplysninger eller forklaring p\xE5 sp\xF8rsm\xE5l."), /*#__PURE__*/React.createElement("p", null, "I andre tilfeller m\xE5 institusjonen avvikle et eksisterende kundeforhold dersom kundekontroll ikke lar seg gjennomf\xF8re. Slike avgj\xF8relser krever en saklig begrunnelse."), /*#__PURE__*/React.createElement("p", {
    className: "no-bottom-margin-paragraph"
  }, "Kilde: Finans Norges informasjon om antihvitvask"), /*#__PURE__*/React.createElement("div", {
    className: "why-done-wrapper"
  }, /*#__PURE__*/React.createElement(StandardButton, {
    type: "button",
    className: "mll btn btn-primary",
    onClick: closeHelpModal,
    id: "hvorfor-done-button"
  }, "Lukk")))))), /*#__PURE__*/React.createElement("div", {
    className: "submitting-buttons"
  }, goBackCallback && goBackText && /*#__PURE__*/React.createElement(LinkButton, {
    onClick: goBackCallback,
    icon: IconTypes.LITEN_PIL_VENSTRE
  }, goBackText), /*#__PURE__*/React.createElement(StandardButton, {
    id: "next-button",
    onClick: onSubmit
  }, submitButtonText)));
};
export default WelcomePage;